export const server = 'https://bits-apiadmin-produccion.azurewebsites.net/api'